module.exports = {"colors":{"page_overlay":"rgba(0, 0, 0, 0.7)"},"fonts":{"primary":{"normal_letter_spacing":"0.3px"}},"images":{"show_partner_icon":"true"},"ob_colors":{"link_dark_mode":"#c8c8c8","link_light_mode":"#707070"},"texts":{"avatar_image_alt_text":"Automatic message"}}


//////////////////
// WEBPACK FOOTER
// ./packages/platform-common-ui/theme.json
// module id = 2368
// module chunks = 0